import { apiRequest } from '../api/client';

export function createMemberAttendanceApi({ fetchImpl } = {}) {
  const request = (path, options) => apiRequest(path, { ...options, fetchImpl });

  function buildQuery(params = {}) {
    const query = new URLSearchParams();
    ['from', 'to', 'limit'].forEach((key) => {
      const value = params[key];
      if (value !== undefined && value !== null && value !== '') query.set(key, String(value));
    });
    const encoded = query.toString();
    return encoded ? `?${encoded}` : '';
  }

  return {
    checkIn: () => request('/me/check-in', { method: 'POST', body: {} }),
    list: (params) => request(`/me/attendance${buildQuery(params)}`).then((result) => result.checkins),
  };
}

export const memberAttendanceApi = createMemberAttendanceApi();
